import type { ApiModuleEndpoints } from '../types'

export const supplierApiEndpoints = {
  list: { method: 'GET', path: '/suppliers', requiresAuth: true },
  options: { method: 'GET', path: '/suppliers/options', requiresAuth: true },
  detail: { method: 'GET', path: '/suppliers/:id', requiresAuth: true },
  create: { method: 'POST', path: '/suppliers', requiresAuth: true },
  update: { method: 'PUT', path: '/suppliers/:id', requiresAuth: true },
  delete: { method: 'DELETE', path: '/suppliers/:id', requiresAuth: true },
  ledger: { method: 'GET', path: '/suppliers/:id/ledger', requiresAuth: true },
  payDebt: { method: 'POST', path: '/suppliers/:id/pay-debt', requiresAuth: true },
  collectDebt: { method: 'POST', path: '/suppliers/:id/collect-debt', requiresAuth: true },
  payments: { method: 'GET', path: '/supplier-payments', requiresAuth: true },
  createPayment: { method: 'POST', path: '/supplier-payments', requiresAuth: true },
  paymentDetail: { method: 'GET', path: '/supplier-payments/:id', requiresAuth: true },
  cancelPayment: { method: 'POST', path: '/supplier-payments/:id/cancel', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
